import { render, staticRenderFns } from "./showListComponent.vue?vue&type=template&id=70153aa2&"
import script from "./showListComponent.vue?vue&type=script&lang=ts&"
export * from "./showListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports